<template>
    <div id="ContainerCustomExportsList">
        <div class="row">
            <div class="col-12">
                <MdTitle v-bind:Text= "$t('CustomExportsList.Title')"/>
                <div class="row">
                    <div class="col-12">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="SearchExports()"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        v-on:click="SearchExports">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div>
                    <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                    <MdTable 
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="refTable"
                        :viewIconEvent="GoToReport"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction"
                    >
                    </MdTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Permission from '@/common/Permission'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import CustomExportsService from '@/services/customExports.service'

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'CustomExportsList',

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
            },
            parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0,
                byUserPermission: true
            },
            ShowMessageIsEmpty:false,
            fields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description'), class: 'text-rigth' },         
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            refTable: 'customReportListTable',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    },

    methods: {
        SearchExports() {
            this.items = []
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getExports();
        },

        getExports() {
            this.$emit('load', true)               
            this.parameter.PageSize = this.perPage;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.byUserPermission = true;

            CustomExportsService.getAll(this.parameter)
                            .then((response) => {
                                if (response.status == '200' ) {
                                    this.items = response.data;
                                    
                                    let headerString = response.headers["x-pagination"];
                                    this.Header = JSON.parse(headerString);
                                    this.totalRows = this.Header.TotalCount;
                                }
                                
                                this.$emit('load', false);
                                if (this.items.length === 0){
                                    this.ShowMessageIsEmpty = true;
                                } 
                            })
                            .catch(error => {
                                this.$emit('load', false);
                                this.showResponseErrorMessage(error);
                            });
        },

        GoToReport(item) {
            this.$router.push({
                name: "customExports",
                params: { id: item.code }
            }).catch(()=>{});
        },

        pageChanged (page) {            
            this.currentPage = page;
            this.getExports();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getExports();
        },
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }    

        this.getExports();
    }
}
</script>